<template>
  <div
    class="findpassword-box show-flex-box-c show-flex-center"
    @click.self="colseFindpasswordWin()"
    v-show="isShowFindpassword"
  >
    <div class="findpassword-total show-flex-box-r show-flex-center">
      <div class="findpassword-all show-flex-box-c">
        <!-- X图标 -->
        <em @click.self="colseFindpasswordWin()"></em>
        <dl class="findpassword-content show-flex-box-c">
          <dt class="select-findpassword-way show-flex-box-r">
            <ul class="select-findpassword-way-list show-flex-box-r">
              <li
                class="select-findpassword-way-item show-flex-box-c"
                :class="{'selected-findpassword-active': findWayType == item.type}"
                v-for="(item, index) in findpasswordOptions"
                :key="index"
                @click="selectedFindpasswordWay(item)"
              >
                <span>{{item.title}}</span>
                <em></em>
              </li>
            </ul>
            <span @click.self="backLogin()">返回登录</span>
          </dt>
          <dd class="account-box show-flex-box-c">
            <div class="account-content-info show-flex-box-c">
              <ul
                class="account-content-password-input message-findpassword-input show-flex-box-c"
                v-if="findWayType == 'phone'"
              >
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input type="text" placeholder="请输入手机号" v-model="messageFindpasswordFrom.phone" />
                  </span>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input
                      type="text"
                      placeholder="请输入验证码"
                      v-model="messageFindpasswordFrom.verifiyCode"
                    />
                  </span>
                  <h3 class="show-flex-box-r" v-if="!countDown">
                    <em></em>
                    <strong @click="verifyCodeCountDown()">获取验证码</strong>
                  </h3>
                  <h4 class="show-flex-box-r" v-else>
                    <em></em>
                    <strong>{{remainCount}}s</strong>
                  </h4>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input
                      type="password"
                      placeholder="请设置密码"
                      v-model="messageFindpasswordFrom.password"
                    />
                  </span>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input
                      type="password"
                      placeholder="请确认密码"
                      v-model="messageFindpasswordFrom.secondPassword"
                    />
                  </span>
                </li>
              </ul>

              <ul
                class="account-content-password-input message-findpassword-input email-findpassword-input show-flex-box-c"
                v-if="findWayType == 'email'"
              >
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input type="text" placeholder="请输入邮箱" v-model="emailFindpasswordFrom.email" />
                  </span>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input
                      type="text"
                      placeholder="请输入验证码"
                      v-model="emailFindpasswordFrom.verifiyCode"
                    />
                  </span>
                  <h3 class="show-flex-box-r" v-if="!emailCountDown">
                    <em></em>
                    <strong @click="verifyCodeCountDown()">获取验证码</strong>
                  </h3>
                  <h4 class="show-flex-box-r" v-else>
                    <em></em>
                    <strong>{{remainEmailCount}}s</strong>
                  </h4>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input
                      type="password"
                      placeholder="请设置密码"
                      v-model="emailFindpasswordFrom.password"
                    />
                  </span>
                </li>
                <li class="show-flex-box-r">
                  <em></em>
                  <span class="show-flex-box-r">
                    <input
                      type="password"
                      placeholder="请确认密码"
                      v-model="emailFindpasswordFrom.secondPassword"
                    />
                  </span>
                </li>
              </ul>
            </div>
            <span class="show-flex-box-r">
              <span @click="clickToFindPassword()">完成</span>
            </span>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import regex from "@/filter/regex";
import { CountDown } from "@/../static/js/CountDown";
// import {FindpasswordUser} from "@/model/login_user.js";

export default {
  name: "findpassword",
  data() {
    return {
      findpasswordOptions: [
        {
          type: "phone",
          title: "手机找回"
        },
        {
          type: "email",
          title: "邮箱找回"
        }
      ],
      isShowFindpassword: false,
      findWayType: "phone",
      remainCount: 60,
      countDown: false,
      remainEmailCount: 60,
      emailCountDown: false,
      reqVerifyCodeLogin: false,
      findPasswordLoading: false,
      messageFindpasswordFrom: {
        phone: "",
        verifiyCode: "",
        password: "",
        secondPassword: ""
      },
      emailFindpasswordFrom: {
        email: "",
        verifiyCode: "",
        password: "",
        secondPassword: ""
      }
    };
  },
  components: {},
  mounted() {},
  methods: {
    colseFindpasswordWin: function() {
      this.isShowFindpassword = !this.isShowFindpassword;
    },
    selectedFindpasswordWay: function(item) {
      this.findWayType = item.type;
    },
    initCountDown: function() {
      var _this = this;
      this.counter = new CountDown(60, function(cnt) {
        if (0 === cnt) {
          (_this.countDown = false), _this.counter && _this.counter.cancel();
        } else {
          _this.remainCount = cnt;
        }
      });
    },
    initEmailCountDown: function() {
      var _this = this;
      this.counter = new CountDown(60, function(cnt) {
        if (0 === cnt) {
          (_this.emailCountDown = false),
            _this.counter && _this.counter.cancel();
        } else {
          _this.remainEmailCount = cnt;
        }
      });
    },
    verifyCodeCountDown: function() {
      if (!this.reqVerifyCodeLogin) {
        if (this.checkCanVerify()) {
          if (this.findWayType == "phone") {
            if (!this.countDown) {
              this.initCountDown();
            }
          } else {
            if (!this.emailCountDown) {
              this.initEmailCountDown();
            }
          }
          this.sendMessage();
        }
      }
    },
    checkCanVerify: function() {
      var status = true;
      if (this.findWayType == "phone") {
        if (regex.isEmpty(this.messageFindpasswordFrom.phone)) {
          this.$message({
            showClose: true,
            message: "请输入您的手机号",
            type: "error"
          });
          return false;
        }
        if (!regex.isPhoneNumber(this.messageFindpasswordFrom.phone)) {
          this.$message({
            showClose: true,
            message: "您输入的手机号格式不正确",
            type: "error"
          });
          return false;
        }
      } else if (this.findWayType == "email") {
        if (regex.isEmpty(this.emailFindpasswordFrom.email)) {
          this.$message({
            showClose: true,
            message: "请输入您的邮箱",
            type: "error"
          });
          return false;
        }
        if (!regex.isEmail(this.emailFindpasswordFrom.email)) {
          this.$message({
            showClose: true,
            message: "您输入的邮箱格式不正确",
            type: "error"
          });
          return false;
        }
      }
      return status;
    },
    sendMessage: function() {
      this.reqVerifyCodeLogin = true;
      var params = {
        account:
          this.findWayType == "phone"
            ? this.messageFindpasswordFrom.phone
            : this.emailFindpasswordFrom.email,
        way: this.findWayType == "phone" ? "phone" : "email",
        type: "find_pwd"
      };
      // alert(JSON.stringify(params));
      this.$client
        .sendVerifyCode(params)
        .then(res => {
          console.log("验证码发送成功");
          console.log(res);

          this.reqVerifyCodeLogin = false;
          if (this.findWayType == "phone") {
            this.countDown = true;
          } else {
            this.emailCountDown = true;
          }
          this.counter.start();
        })
        .catch(err => {
          this.reqVerifyCodeLogin = false;
          this.counter && this.counter.cancel();
          this.emailCountDown = false;
          this.countDown = false;
          console.log("验证码发送失败");
          console.log(err);
          if (err.data && err.data.message) {
            this.$message({
              showClose: true,
              message: err.data.message,
              type: "error"
            });
          }
        });
    },
    clickToFindPassword: function() {
      if (this.checkCanVerify() && this.validRegisterParams()) {
        var params = {
          account:
            this.findWayType == "phone"
              ? this.messageFindpasswordFrom.phone
              : this.emailFindpasswordFrom.email,
          way: this.findWayType,
          verify_code:
            this.findWayType == "phone"
              ? this.messageFindpasswordFrom.verifiyCode
              : this.emailFindpasswordFrom.verifiyCode,
          password:
            this.findWayType == "phone"
              ? this.messageFindpasswordFrom.password
              : this.emailFindpasswordFrom.password
        };
        // alert(JSON.stringify(params));
        // return;
        if (!this.findPasswordLoading) {
          this.findPasswordLoading = true;
          this.$client
            .findPassword(params)
            .then(res => {
              console.log("修改成功");
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  showClose: true,
                  message: "密码已修改",
                  type: "success"
                });
                this.resetForm();
                this.findPasswordLoading = false;
                this.isShowFindpassword = false;
              }
            })
            .catch(err => {
              console.log("修改失败");
              console.log(err);
              if (err.data && err.data.message) {
                this.$message({
                  showClose: true,
                  message: err.data.message,
                  type: "error"
                });
              }
              this.findPasswordLoading = false;
            });
        }
      }
    },
    validRegisterParams: function() {
      var status = true;
      if (this.findWayType == "phone") {
        if (regex.isEmpty(this.messageFindpasswordFrom.verifiyCode)) {
          this.$message({
            showClose: true,
            message: "请输入您收到的验证码",
            type: "error"
          });
          return false;
        }
        if (regex.isEmpty(this.messageFindpasswordFrom.password)) {
          this.$message({
            showClose: true,
            message: "请输入您的密码",
            type: "error"
          });
          return false;
        }
        if (
          this.messageFindpasswordFrom.password !=
          this.messageFindpasswordFrom.secondPassword
        ) {
          this.$message({
            showClose: true,
            message: "您两次输入的密码不一致",
            type: "error"
          });
          return false;
        }
        return status;
      } else {
        if (regex.isEmpty(this.emailFindpasswordFrom.verifiyCode)) {
          this.$message({
            showClose: true,
            message: "请输入您收到的验证码",
            type: "error"
          });
          return false;
        }
        if (regex.isEmpty(this.emailFindpasswordFrom.password)) {
          this.$message({
            showClose: true,
            message: "请输入您的密码",
            type: "error"
          });
          return false;
        }
        if (
          this.emailFindpasswordFrom.password !=
          this.emailFindpasswordFrom.secondPassword
        ) {
          this.$message({
            showClose: true,
            message: "您两次输入的密码不一致",
            type: "error"
          });
          return false;
        }
        return status;
      }
    },

    resetForm: function() {
      this.remainCount = 60;
      this.countDown = false;
      this.remainEmailCount = 60;
      this.emailCountDown = false;
      this.findPasswordLoading = false;
      this.messageFindpasswordFrom.phone = "";
      this.messageFindpasswordFrom.verifiyCode = "";
      this.messageFindpasswordFrom.password = "";
      this.messageFindpasswordFrom.secondPassword = "";
      this.emailFindpasswordFrom.email = "";
      this.emailFindpasswordFrom.verifiyCode = "";
      this.emailFindpasswordFrom.password = "";
      this.emailFindpasswordFrom.secondPassword = "";
    },
    backLogin: function() {
      this.$parent.$refs.login.colseLoginWin();
      this.isShowFindpassword = false;
    }
  },
  watch: {
    isShowFindpassword: function() {
      this.resetForm();
    }
  }
};
</script>
<style lang="less" scoped>
.findpassword-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.4);
  .findpassword-total {
    width: 560px;
    padding: 30px 0px 60px 0px;
    background: #ffffff;
    border-radius: 8px;
    position: absolute;
    .findpassword-all {
      width: 506px;
      height: 100%;
      align-items: flex-end;
      padding-left: 22px;
      > em {
        display: block;
        width: 22px;
        height: 22px;
        background: url("../../assets/login/close_arrow_icon.png") no-repeat
          center center;
        background-size: 22px 22px;
        margin-bottom: 18px;
        flex-shrink: 0;
        cursor: pointer;
      }
      > dl {
        width: 100%;
        > dt {
          padding-right: 23px;
          align-items: flex-end;
          margin-bottom: 30px;
          > ul {
            width: 100%;
            align-items: center;
            > li {
              align-items: center;
              margin-right: 25px;
              cursor: pointer;
              > span {
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 33px;
                white-space: nowrap;
                flex-shrink: 0;
                margin-bottom: 5px;
              }
              // >em{
              //   width:35px;
              //   height:5px;
              //   background:#CB1309;
              //   border-radius:3px;
              // }
            }
            .selected-findpassword-active {
              > span {
                color: #333333;
              }
              > em {
                width: 35px;
                height: 5px;
                background: #cb1309;
                border-radius: 3px;
              }
            }
          }
          > span {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 21px;
            white-space: nowrap;
            flex-shrink: 0;
            margin-bottom: 10px;
            cursor: pointer;
          }
        }
        .account-box {
          width: 100%;
          .account-content-info {
            padding-right: 23px;
            .account-content-password-input {
              width: 100%;
              > li {
                padding: 0px 15px;
                height: 60px;
                background: #fafafa;
                box-shadow: 3px 3px 3px 0px #f4f4f9;
                border-radius: 4px;
                border: 1px solid #eeeeef;
                margin-bottom: 20px;
                align-items: center;
                cursor: pointer;
                > em {
                  width: 20px;
                  height: 20px;
                  display: block;
                  background: url(../../assets/login/account_icon.png) no-repeat
                    center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                }
                > span {
                  flex-grow: 1;
                  margin-left: 20px;
                  align-items: center;
                  > input {
                    width: 100%;
                    height: 100%;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 22px;
                  }
                }
                > strong {
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #cb1309;
                  line-height: 17px;
                  cursor: pointer;
                }
              }
              > li:hover {
                padding: 0px 15px;
                height: 60px;
                background: rgba(203, 19, 9, 0.04);
                box-shadow: 3px 3px 3px 0px rgba(203, 19, 9, 0.1);
                border-radius: 4px;
                border: 1px solid rgba(203, 19, 9, 1);
              }
              > li:nth-child(3) {
                > em {
                  flex-shrink: 0;
                  width: 20px;
                  height: 20px;
                  display: block;
                  background: url(../../assets/login/password_icon.png)
                    no-repeat center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                }
              }

              > li:nth-child(4) {
                > em {
                  flex-shrink: 0;
                  width: 20px;
                  height: 20px;
                  display: block;
                  background: url(../../assets/login/password_icon.png)
                    no-repeat center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                }
              }
            }
            .message-findpassword-input {
              > li > em {
                width: 20px;
                height: 20px;
                display: block;
                background: url(../../assets/login/tel_icon.png) no-repeat
                  center center;
                background-size: 100% 100%;
                flex-shrink: 0;
              }
              > li:nth-child(2) > em {
                width: 20px;
                height: 20px;
                display: block;
                background: url(../../assets/login/verify_icon.png) no-repeat
                  center center;
                background-size: 100% 100%;
                flex-shrink: 0;
              }
              > li:nth-child(2) > h3 {
                width: 80px;
                padding-left: 15px;
                height: 20px;
                border-left: 1px #cb1309 solid;
                flex-shrink: 0;
                > em {
                  width: 15px;
                  height: 15px;
                  display: block;
                  background: url(../../assets/login/message_icon.png) no-repeat
                    center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                  margin-top: 3px;
                }
                > strong {
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #cb1309;
                  line-height: 20px;
                  margin-left: 5px;
                  cursor: pointer;
                  flex-shrink: 0;
                  white-space: nowrap;
                }
              }
              > li:nth-child(2) > h4 {
                width: 60px;
                padding-left: 35px;
                height: 20px;
                border-left: 1px #cb1309 solid;
                flex-shrink: 0;
                cursor: default;
                > em {
                  width: 15px;
                  height: 15px;
                  display: block;
                  background: url(../../assets/login/gray_message_icon.png)
                    no-repeat center center;
                  background-size: 100% 100%;
                  flex-shrink: 0;
                  margin-top: 3px;
                }
                > strong {
                  font-size: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #cccccc;
                  line-height: 20px;
                  margin-left: 5px;
                }
              }
            }

            .email-findpassword-input {
              > li > em {
                width: 20px;
                height: 20px;
                display: block;
                background: url(../../assets/login/email_icon.png) no-repeat
                  center center;
                background-size: 100% 100%;
                flex-shrink: 0;
              }
              // >li:nth-child(2)>em{
              //   width: 20px;
              //   height: 20px;
              //   display: block;
              //   background: url(../../assets/login/verify_icon.png) no-repeat center center;
              //   background-size: 100% 100%;
              //   flex-shrink: 0;
              // }
            }
          }
          > h3 {
            align-items: center;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 18px;
            margin-bottom: 30px;
            > span {
              color: #999999;
            }
            > em {
              color: #666666;
              cursor: pointer;
            }
          }
          > span {
            padding-right: 23px;
            margin-top: 10px;
            > span {
              cursor: pointer;
              width: 100%;
              height: 60px;
              background: #cb1309;
              box-shadow: 0px 2px 4px 0px #cb1309;
              border-radius: 4px;
              line-height: 60px;
              text-align: center;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(255, 255, 255, 1);
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/find_password.vue